<div class="flex justify-between m-2 w-full">
    <div class="flex gap-2 space-between px-6 pt-4 pb-2 w-full">
        <div class="flex gap-2">
            <div class="flex items-center">
            <p-datepicker [(ngModel)]="initialDate" dateFormat="dd/mm/yy" />
        </div>
        <div class="flex items-center">
            <p-datepicker [(ngModel)]="finalDate" dateFormat="dd/mm/yy" />
        </div>

        <p-button (onClick)="getData()" label="Buscar"></p-button>
    </div>

    <div class="flex gap-3">
        <div class="flex items-center">
            <p-button (onClick)="goBack()" label="Voltar"></p-button>
        </div>
        <div class="flex items-center">
            <p-button (onClick)="export()" label="Exportar"></p-button>
        </div>
    </div>
</div>
